import { toast } from 'react-toastify';
import FileUploadAPI from '../FileUploadAPI';
export const FileUpload = (additionalData) => {
    return new Promise((resolve,reject) => {
        const formData = new FormData();

        // Append all additional data, including the file
        for (const key in additionalData) {
            if (additionalData.hasOwnProperty(key)) {
                formData.append(key, additionalData[key]);
            }
        }

        FileUploadAPI.post(`/files/`, formData)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            reject(error);
            console.log(error);
        });
    });
};

export const FileUploadGet = (fileId) => {
    return new Promise((resolve,reject) => {
        FileUploadAPI.get(`/files/${encodeURIComponent(fileId)}`)
          .then(response => {
            resolve(response);
          })
          .catch(error =>{
            reject(error);
            console.log(error)
          });
      });
};